export default function VisitorPage() {
  return (
    <ul>
      <li>Visitor: </li>
    </ul>
  );
}
